{
  "version": 1,
  "asset_id": "0f13224f-71b2-4656-8983-c98149dca820",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/0f13224f-71b2-4656-8983-c98149dca820/destination-roofing-owner-dump-trailer-crystal-river-fl-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/0f13224f-71b2-4656-8983-c98149dca820/destination-roofing-owner-dump-trailer-crystal-river-fl-1200w.webp",
  "original_filename": "destination-roofing-owner-dump-trailer-crystal-river-fl-1200w.webp",
  "size": 93742,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:32Z"
}
